import { ArrowBack, ArrowForward, CompareArrows } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { observable, action, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { ControleGabinete, TipoControle } from '../../modelo';
import Card from './Card';

import './css/kanban.css';
import MensagemStore from '../../store/MensagemStore';
import ControleGabineteStore from '../../store/ControleGabineteStore';
import ParametroStore from '../../store/ParametroStore';
import ProcessoStore from '../../store/ProcessoStore';

interface IPropsKanBan {
    items: ControleGabinete[];
    isConfig: boolean;
    // callBackAtualizarItems?: (param1) => any;
}


class Kanban extends React.Component<IPropsKanBan> {
    isConfig = this.props.isConfig;
    indiceRenderizacaoMax = 15;
    private cancelarCarregamentoPendente?: () => void;

    constructor(props: IPropsKanBan) {
        super(props);

        makeObservable(this, {
            isConfig: observable,
            indiceRenderizacaoMax: observable,
incrementarRenderizacao: action
        });
    }

    get items() {
        return this.props.items;
    }

    componentDidMount() {
        this.iniciarCarregamentoProgressivo();
    }

    componentDidUpdate(prevProps: IPropsKanBan) {
        if (prevProps.items.length !== this.props.items.length) {
            this.indiceRenderizacaoMax = 15;
            this.iniciarCarregamentoProgressivo();
        }
    }

    componentWillUnmount() {
        this.cancelarCarregamento();
    }

    iniciarCarregamentoProgressivo = () => {
        this.cancelarCarregamento();

        const totalCards = this.items.filter(item => item.ativo).length;
        if (this.indiceRenderizacaoMax >= totalCards) return;

        const carregarProximo = () => {
            this.cancelarCarregamentoPendente = undefined;

            if (this.indiceRenderizacaoMax < totalCards) {
                this.incrementarRenderizacao();
                this.agendarCarregamento(carregarProximo);
            }
        };

        this.agendarCarregamento(carregarProximo);
    }

    agendarCarregamento = (callback: () => void) => {
        const requestIdle = window.requestIdleCallback;
        const cancelIdle = window.cancelIdleCallback;

        if (requestIdle) {
            const id = requestIdle(callback, { timeout: 1000 });
            this.cancelarCarregamentoPendente = () => cancelIdle?.(id);
            return;
        }

        const id = window.setTimeout(callback, 0);
        this.cancelarCarregamentoPendente = () => window.clearTimeout(id);
    }

    cancelarCarregamento = () => {
        this.cancelarCarregamentoPendente?.();
        this.cancelarCarregamentoPendente = undefined;
    }

    incrementarRenderizacao = () => {
        const totalCards = this.items.filter(item => item.ativo).length;
        const proximoIndice = Math.min(this.indiceRenderizacaoMax + 5, totalCards);
        this.indiceRenderizacaoMax = proximoIndice;
    };

    podeSerExcluido = (oldIndex) => {
        return (this.items[oldIndex].tipo.permiteExclusao === true && this.items[oldIndex].tipo.id === 2)
            && (this.items[oldIndex].count <= 0 || !this.items[oldIndex].count);
    }

    verificarExclusao = (oldIndex) => {
        if (this.podeSerExcluido(oldIndex)) {
            const cards = this.items;
            cards[oldIndex].ativo = false;
            const removido = cards.splice(oldIndex, 1)[0];
            cards.push(removido);
        } else if (this.items[oldIndex].tipo.permiteExclusao !== true || this.items[oldIndex].tipo.id !== 2) {
            MensagemStore.apresentarErro("A movimentação não pode ser excluída pois é de um tipo que não permite exclusão.");
        } else if (this.items[oldIndex].count > 0) {
            MensagemStore.apresentarErro("A movimentação não pode ser excluída pois possui processo(s) associado(s) a ela.");
        }
    }

    cardVisivelComFiltroOjc = (card: ControleGabinete) => {
        const visAtiva = ControleGabineteStore.visibilidadeAtiva;
        const filtroOJC = ControleGabineteStore.filtroOJC;

        if (visAtiva) {
            return true;
        }

        if (!filtroOJC) {
            return true;
        }

        if (card.tipo.id !== TipoControle.LISTAGEM) {
            return false;
        }

        return ProcessoStore.processosDoControle(card.numero, true, filtroOJC).length > 0;
    }

    render() {
        const containerClass = ControleGabineteStore.isVisualizacaoEmLista
            ? 'lista-container'
            : 'aligner-container';
        const isConfigLista = this.isConfig && ControleGabineteStore.isVisualizacaoEmLista;
        const itensAtivos = this.items.filter(item => item.ativo);
        const deveAvaliarVisibilidadePorOjc =
            !this.isConfig &&
            (!!ControleGabineteStore.filtroOJC || !ControleGabineteStore.visibilidadeAtiva);
        const temCardsVisiveisComFiltro = !deveAvaliarVisibilidadePorOjc
            ? true
            : itensAtivos.some(item => this.cardVisivelComFiltroOjc(item));
        const exibirMensagemVazio =
            !ControleGabineteStore.existeResultadoBusca ||
            (!this.isConfig && !temCardsVisiveisComFiltro);

        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className={containerClass}>
                    {this.isConfig ?
                        <div
                            id='container'
                            className={containerClass}
                        >
                            {itensAtivos
                                .map((item, index) => {
                                    const cardsEspeciais = (item.tipo.id === TipoControle.LISTAGEM);
                                    const podeMoverEsquerda = item.tipo.id === 2 &&
                                        itensAtivos[index - 1]?.tipo.id !== 2 &&
                                        index > 2 &&
                                        cardsEspeciais;
                                    const podeMoverDireitaComTroca = cardsEspeciais &&
                                        (index + 1) < itensAtivos.length &&
                                        itensAtivos[index + 1]?.tipo.id === TipoControle.LISTAGEM;
                                    const podeMoverDireita = index >= 2 &&
                                        (index + 2) < itensAtivos.length &&
                                        cardsEspeciais;
                                    const possuiAcaoDireita = podeMoverDireitaComTroca || podeMoverDireita;

                                    return (
                                        <div
                                            key={'kanban-' + (item.numero ?? `novo-${item.tipo.id}-${index}`)}
                                            className={`divConfiguracao ${isConfigLista ? 'divConfiguracaoLista' : ''}`}
                                        >
                                            {isConfigLista && podeMoverEsquerda && (
                                                <div className='acoesReordenacaoLista acoesReordenacaoListaTopo'>
                                                    <IconButton
                                                        className='botaoSetaCentralizada'
                                                        onClick={ControleGabineteStore.trocarComIndiceMenor.bind(this, index)}
                                                    >
                                                        <ArrowBack />
                                                    </IconButton>
                                                </div>
                                            )}

                                            {!isConfigLista && podeMoverEsquerda && (
                                                <IconButton
                                                    className='botaoSetaCentralizada'
                                                    onClick={ControleGabineteStore.trocarComIndiceMenor.bind(this, index)}
                                                >
                                                    <ArrowBack />
                                                </IconButton>
                                            )}

                                            <Card
                                                card={item}
                                                index={index}
                                                visualizandoKanban={!ControleGabineteStore.isVisualizacaoEmLista}
                                                isConfig={true}
                                            />

                                            {isConfigLista && possuiAcaoDireita && (
                                                <div className='acoesReordenacaoLista acoesReordenacaoListaBase'>
                                                    {podeMoverDireitaComTroca ? (
                                                        <IconButton
                                                            className='botaoSetaCentralizada'
                                                            onClick={ControleGabineteStore.trocarComIndiceMaior.bind(this, index)}
                                                        >
                                                            <CompareArrows />
                                                        </IconButton>
                                                    ) : (
                                                        podeMoverDireita && (
                                                            <IconButton
                                                                className='botaoSetaCentralizada'
                                                                onClick={ControleGabineteStore.trocarComIndiceMaior.bind(this, index)}
                                                            >
                                                                <ArrowForward />
                                                            </IconButton>
                                                        )
                                                    )}
                                                </div>
                                            )}

                                            {!isConfigLista && podeMoverDireitaComTroca ? (
                                                <IconButton
                                                    className='botaoSetaCentralizada'
                                                    onClick={ControleGabineteStore.trocarComIndiceMaior.bind(this, index)}
                                                >
                                                    <CompareArrows />
                                                </IconButton>
                                            ) : (
                                                !isConfigLista &&
                                                podeMoverDireita && (
                                                    <IconButton
                                                        className='botaoSetaCentralizada'
                                                        onClick={ControleGabineteStore.trocarComIndiceMaior.bind(this, index)}
                                                    >
                                                        <ArrowForward />
                                                    </IconButton>
                                                )
                                            )
                                            }
                                        </div>
                                    );
                                })}
                        </div>
                        :
                        this.items.slice(0, this.indiceRenderizacaoMax).map((item, index) => (
                            item.ativo && (
                                <Card
                                    key={index}
                                    card={item}
                                    isConfig={this.isConfig}
                                    visualizandoKanban={!ControleGabineteStore.isVisualizacaoEmLista}
                                    index={item.index}
                                />
                            )
                        ))
                    }
                    {exibirMensagemVazio && (
                        <div className="nenhum-resultado">
                            Nenhum controle ou servidor encontrado.
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default observer(Kanban);
